import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=023132c4&scoped=true&"
import script from "./StatsView.vue?vue&type=script&lang=ts&"
export * from "./StatsView.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=023132c4&prod&scoped=true&lang=css&"
import style1 from "./StatsView.vue?vue&type=style&index=1&id=023132c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023132c4",
  null
  
)

export default component.exports